import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  partnerDetails: null,
  partnerCampaigns: [],
  partnerStatements: [],
  partnerTransactions: [],
};

const partnerSlice = createSlice({
  name: "partner",
  initialState,
  reducers: {
    setPartnerDetails(state, action) {
      state.partnerDetails = action?.payload;
    },
    setPartnerCampaigns(state, action) {
      state.partnerCampaigns = action?.payload;
    },
    setPartnerStatements(state, action) {
      state.partnerStatements = action.payload;
    },
    setPartnerTransactions(state, action) {
      state.partnerTransactions = action.payload;
    },
  },
});

export const {
  setPartnerDetails,
  setPartnerCampaigns,
  setPartnerStatements,
  setPartnerTransactions,
} = partnerSlice.actions;
export default partnerSlice.reducer;
